import React from "react";
import {NavLink, Route, Switch} from "react-router-dom"
import {rolePageMapping} from "./utils/roles";


const Navbar = (props) => {
    return (
        <div className="Navbar">
            <Switch>
                <Route>
                    <div className="tableWrapper">
                        {(props.tabsEnabledStatus === 'MINIMAL') ? (
                            <ul className="header">
                                {
                                    rolePageMapping.fwcatalog.includes(props.role)
                                    &&
                                    <li><NavLink to="/fw-catalog">FW Catalog</NavLink></li>
                                }

                            </ul>) : (<ul className="header">

                                {
                                    rolePageMapping.accountManagement.includes(props.role)
                                    &&
                                    <li><NavLink to="/sps-account-home">Account Management</NavLink></li>
                                }
                                {
                                    rolePageMapping.monthlyPrice.includes(props.role)
                                    &&
                                    <li><NavLink to="/sps-monthlyprice">Monthly Cap and Pricing</NavLink></li>
                                }
                                {
                                    rolePageMapping.fwcatalog.includes(props.role)
                                    &&
                                    <li><NavLink to="/fw-catalog">FW Catalog</NavLink></li>
                                }
                                {
                                    rolePageMapping.administration.includes(props.role)
                                    &&
                                    <li><NavLink to="/sps-admin">Administration</NavLink></li>
                                }
                            </ul>
                        )}
                    </div>
                </Route>
            </Switch>
        </div>
    )
}

export default Navbar;